module.exports = __webpack_public_path__ + "static/worldMask-26d3b5b3deb5a46dc4faf80819d91766.jpg";